import theme from 'styled-theming';

export const backgroundColor = theme('mode', {
  light: '#e6ecf0',
  dark: '#202327',
});

export const textColor = theme('mode', {
  light: '#000',
  dark: '#fff',
});

export const divBackgroundColor = theme('mode', {
  light: '#fff',
  dark: '#000',
});

export const borderColor = theme('mode', {
  light: '#cad1d7',
  dark: '#222222',
});

export const buttonBackgroundColor = theme('mode', {
  light: '#222',
  dark: '#eee',
});

export const buttonTextColor = theme('mode', {
  light: '#eee',
  dark: '#222',
});

/**
 * Color global style constants
 */
export const colors = {
  warning: '#FF5722',
  doselectGreen: '#2ECC71',
  silver: '#bdc3c7',
  white: '#fff',
  black: '#000',
  globalBackground: '#e6ecf0',
  subTitle: '#616161',
  primary: '#101130',
  success: '#28a745',
  danger: '#dc3545',
  disabled: '#9099a9',
};
